import { observer } from 'mobx-react-lite';
import React from 'react';
import { DOCUMENTS_CONTENT_TYPE } from '../../../../architecture/constants/Media';
import { MediaTypes } from '../../../../architecture/enums/MediaType';
import { KnowledgebaseEntry } from '../../../../models/Knowledgebase/KnowledgebaseEntry';
import Files from './components/Files';

interface IProps {
  entry: KnowledgebaseEntry;
}

const Document: React.FC<IProps> = ({ entry }) => {
  return (
    <>
      <div className='title'></div>
      <p className='subtitle'>Select a document from your library:</p>
      <Files
        mediaType={MediaTypes.Document}
        entry={entry}
        mediaFiles={entry.mediaFiles.filter((media) =>
          DOCUMENTS_CONTENT_TYPE.includes(media.contentType)
        )}
      />
    </>
  );
};

export default observer(Document);
